module.exports = "<asui-loading-mask ng-if=\"$ctrl.show\" show=\"$ctrl.show\"></asui-loading-mask>\n";


//////////////////
// WEBPACK FOOTER
// ./modules/shared/components/asLoadingIcon/asLoadingIcon.component.html
// module id = 711
// module chunks = 0